import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { UpdateOrderItemsPayloadWithAuth } from "../shared/types";

const orderRepo = OrderRepositoryImpl.getInstance();

const useAddProductToBasket = () => {
  const queryClient = useContext(queryClientContext);

  const mutation = useMutation(
    {
      mutationFn: async (productToAdd: UpdateOrderItemsPayloadWithAuth) => {
        return orderRepo.addItem(productToAdd);
      },
    },
    queryClient,
  );

  const addProductToBasket = useCallback(
    (payload: UpdateOrderItemsPayloadWithAuth, onSuccess: () => void, onError?: (error: unknown) => void) => {
      mutation.mutate(payload, { onSuccess, onError });
    },
    [mutation],
  );

  return addProductToBasket;
};

export { useAddProductToBasket };
